import { LockOutlined } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  Tooltip,
  Typography,
} from '@mui/material';

const ManageColumnsDialog = ({ open, onClose, visibleColumns, setVisibleColumns }) => {
  const handleToggle = (columnId) => {
    setVisibleColumns((prev) => prev.map((col) => (col.accessorKey === columnId ? { ...col, visible: !col.visible } : col)));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      {/* Title with Close Button */}
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', position: 'relative' }}>
        MANAGE COLUMNS
        <IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* Wrapper to align title and list properly */}
        <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2 }}>
          {/* Columns Title */}
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
            COLUMNS
          </Typography>

          {/* List of Columns */}
          <List sx={{ padding: 0 }}>
            {visibleColumns.map((column) => (
              <ListItem key={column.meta?.headerTitle} sx={{ paddingY: 0.5, pl: 0 }}>
                {column.meta?.locked ? (
                  <Tooltip title="This column is locked and cannot be hidden">
                    <Box display="flex" alignItems="center" gap={0.5} ml={-0.5}>
                      <LockOutlined />
                      <Typography variant="body2">{column.meta?.headerTitle?.toUpperCase()}</Typography>
                    </Box>
                  </Tooltip>
                ) : (
                  <FormControlLabel
                    control={
                      <Checkbox checked={column.visible} onChange={() => handleToggle(column.accessorKey)} color="primary" />
                    }
                    label={<Typography variant="body2">{column.meta?.headerTitle}</Typography>}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>

      <DialogActions sx={{ paddingX: 3, paddingY: 2 }}>
        {/* <Button onClick={onClose} variant="contained" color="primary">
          Save
        </Button> */}
        <Button onClick={onClose} variant="outlined" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManageColumnsDialog;
